"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var PublicKey_1 = require("../keys/PublicKey");
var Message_1 = require("./Message");
var SessionTag_1 = require("./SessionTag");
var InputError_1 = require("../errors/InputError");
var CipherMessage = (function (_super) {
    __extends(CipherMessage, _super);
    function CipherMessage() {
        var _this = _super.call(this) || this;
        _this.cipher_text = new Uint8Array([]);
        _this.counter = -1;
        _this.prev_counter = -1;
        _this.ratchet_key = new PublicKey_1.default();
        _this.session_tag = new SessionTag_1.default();
        return _this;
    }
    CipherMessage.new = function (session_tag, counter, prev_counter, ratchet_key, cipher_text) {
        var cm = ClassUtil_1.default.new_instance(CipherMessage);
        cm.session_tag = session_tag;
        cm.counter = counter;
        cm.prev_counter = prev_counter;
        cm.ratchet_key = ratchet_key;
        cm.cipher_text = cipher_text;
        Object.freeze(cm);
        return cm;
    };
    CipherMessage.prototype.encode = function (encoder) {
        encoder.object(5);
        encoder.u8(0);
        this.session_tag.encode(encoder);
        encoder.u8(1);
        encoder.u32(this.counter);
        encoder.u8(2);
        encoder.u32(this.prev_counter);
        encoder.u8(3);
        this.ratchet_key.encode(encoder);
        encoder.u8(4);
        return encoder.bytes(this.cipher_text);
    };
    CipherMessage.decode = function (decoder) {
        var session_tag = null;
        var counter = null;
        var prev_counter = null;
        var ratchet_key = null;
        var cipher_text = null;
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    session_tag = SessionTag_1.default.decode(decoder);
                    break;
                case 1:
                    counter = decoder.u32();
                    break;
                case 2:
                    prev_counter = decoder.u32();
                    break;
                case 3:
                    ratchet_key = PublicKey_1.default.decode(decoder);
                    break;
                case 4:
                    cipher_text = new Uint8Array(decoder.bytes());
                    break;
                default:
                    decoder.skip();
            }
        }
        counter = Number(counter);
        prev_counter = Number(prev_counter);
        if (session_tag && !isNaN(counter) && !isNaN(prev_counter) && ratchet_key && cipher_text) {
            return CipherMessage.new(session_tag, counter, prev_counter, ratchet_key, cipher_text);
        }
        else {
            throw new InputError_1.default.TypeError("Given CipherMessage doesn't match expected signature.", InputError_1.default.CODE.CASE_405);
        }
    };
    return CipherMessage;
}(Message_1.default));
exports.default = CipherMessage;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/message/CipherMessage.js
// module id = 21
// module chunks = 0 1